module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Stop-c31fc50dc5b12ecff6eda25501272a11.svg";